const recipesIngredientsProducts = () => {
  const width = $(window).width();
  const recipeIngredientsSelector = '[id*=recipes-ingredients-products-]';
  function initSlick() {
    const sliderSelector = `${recipeIngredientsSelector} .recipe-products-list`;
    if (width <= 768) {
      // mobile screens
      $(sliderSelector).slick({
        arrows: false,
        vertical: false,
        dots: true,
        draggable: true,
        infinite: false,
        centerMode: false,
        adaptiveHeight: true,
        slidesToShow: 1,
        rows: 2,
        slidesPerRow: 1,
        verticalSwiping: false,
      });
    }
  }

  function repositionRecipesSection() {
    $(recipeIngredientsSelector).each((index, element) => {
      let referenceElement = '.btn-container:visible';
      if (width <= 820) {
        referenceElement = '.recipes-ingredients-products-image';
      }

      let referenceTopPosition = $(element).find(
        '.recipes-ingredients-products-info',
      );
      if (referenceTopPosition.length) {
        referenceTopPosition = referenceTopPosition
          .find(referenceElement)
          .position().top;
      }

      width > 768 &&
        $(element)
          .find('.recipes-ingredients-products-container')
          .css('top', `${referenceTopPosition}px`);
    });
  }

  function initAddAllProductToCart() {
    $(document).on('click', '.recipes-ingredients-add-to-cart-btn', (event) => {
      const currentTarget = $(event.target);
      const variantIds = [];
      let increment = 0;
      currentTarget
        .first()
        .closest('[id*=recipes-ingredients-products-]')
        .find('.recipes-ingredients-products-box')
        .each((index, element) => {
          const variantId = $(element)
            .find('[data-variant-id]:enabled')
            .data('variant-id');
          if (variantId) {
            variantIds.push(variantId);
          }
        });

      function addAllProductsToCart() {
        if (increment < variantIds.length) {
          const variantId = variantIds[increment];
          $.ajax({
            type: 'POST',
            url: '/cart/add',
            data: { quantity: 1, id: variantId },
            dataType: 'json',
          }).done(function () {
            increment++;
            if (increment === variantIds.length) {
              openMiniCart();
              refreshMiniCart();
              //   window.location.href = '/cart';
            } else {
              addAllProductsToCart();
            }
          });
        }
      }
      addAllProductsToCart();
    });
  }

  function openMiniCart() {
    // Open minicart here
    $('.mrMiniCart-drawer').addClass('active');
  }

  function refreshMiniCart() {
    $.ajax({
      type: 'GET',
      url: '/cart',
      dataType: 'html',
    }).done(function (data) {
      const miniCartContent = $(data).find('.mrMiniCart-items').html();
      const cartCountElement = $(data).find('.mrMiniCart-header-count');

      // Update the minicart items
      $('.mrMiniCart-items').html(miniCartContent).removeClass('is-empty');
      $('.mrMiniCart-drawer .drawer__inner-empty').hide();

      // Update the cart count
      if (cartCountElement.length) {
        const cartCount = cartCountElement.text();
        $('.mrMiniCart-header-count').text(cartCount);

        // Update the cart count bubble
        const cartCountBubble = $('.cart-count-bubble');
        cartCountBubble.find('span[aria-hidden="true"]').text(cartCount);
        cartCountBubble.toggleClass('empty', cartCount === '0');

        // Remove 'is-empty' class from cart-drawer if mini cart has items
        const cartDrawer = $('.mrMiniCart-drawer');
        if (cartCount !== '0') {
          cartDrawer.removeClass('is-empty');
        }
      }
    });
  }

  initSlick();
  repositionRecipesSection();
  initAddAllProductToCart();
};

export default recipesIngredientsProducts;
